<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Pending Approval</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">PERMITS PENDING APPROVAL</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Pending Approval</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Pending</p>
                      <h4 class="mb-0">{{ numberFormat(totalBusiness) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-time-five font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Value</p>
                      <h4 class="mb-0">KES {{ numberFormat(totalAmount) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Displayed Records</p>
                      <h4 class="mb-0">{{ pagination.totalRecords }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-list-ul font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Status</p>
                      <h4 class="mb-0 text-warning">Awaiting Approval</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-check-shield font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ToolBarHygiene/>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="card-title mb-0 text-uppercase">
                      <i class="bx bx-shield-quarter me-2"></i>HYGIENE PERMITS PENDING APPROVAL
                    </h4>
                    <div>
                      <button @click="exportToCSV" class="btn btn-success btn-sm me-2">
                        <i class="bx bx-download me-1"></i> Export CSV
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-light pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-between p-3 w-100">
                    <div class="flex-grow-1 me-3">
                      <form class="app-search p-0 m-0" @submit.prevent>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by Business Name, ID, Bill Number, or Officer Name..."
                                 spellcheck="false" data-ms-editor="true"
                                 @input="handleSearchInput">
                          <span class="bx bx-search-alt"></span>
                        </div>
                      </form>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="me-2">
                        <input type="date" v-model="filterDateRange.startDate" class="form-control form-control-sm"
                               placeholder="Start Date" @change="applyDateFilter" title="Filter by start date"/>
                      </div>
                      <div class="me-2">
                        <input type="date" v-model="filterDateRange.endDate" class="form-control form-control-sm"
                               placeholder="End Date" @change="applyDateFilter" title="Filter by end date"/>
                      </div>
                      <div class="me-2" v-if="filterDateRange.startDate || filterDateRange.endDate">
                        <button @click="clearDateFilter" class="btn btn-sm btn-outline-danger" title="Clear date filter">
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                      <div>
                        <select v-model="pageSize" @change="handlePageSizeChange" class="form-select form-select-sm">
                          <option value="10">10 per page</option>
                          <option value="25">25 per page</option>
                          <option value="50">50 per page</option>
                          <option value="100">100 per page</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Active Filter Indicator -->
                <div v-if="filterDateRange.startDate || filterDateRange.endDate || search" class="card-body py-2 bg-light border-bottom">
                  <div class="d-flex align-items-center flex-wrap gap-2">
                    <i class="bx bx-filter-alt text-primary me-2"></i>
                    <small class="text-muted">
                      <strong>Active Filters:</strong>
                    </small>
                    <span v-if="filterDateRange.startDate || filterDateRange.endDate" class="badge bg-primary">
                      Date: {{ filterDateRange.startDate || 'Any' }} to {{ filterDateRange.endDate || 'Any' }}
                    </span>
                    <span v-if="search" class="badge bg-info">
                      Search: "{{ search }}"
                    </span>
                    <button @click="clearAllFilters" class="btn btn-link btn-sm ms-auto text-danger">
                      Clear All Filters
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading pending approvals...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="pendingInvoicing.length === 0" class="text-center py-5">
                    <div class="mb-4">
                      <i class="bx bx-search-alt font-size-64 text-muted"></i>
                    </div>
                    <h5 class="text-muted">No Pending Approvals Found</h5>
                    <p class="text-muted">{{ search ? 'Try adjusting your search criteria' : 'There are no permits pending approval at the moment' }}</p>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover table-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">Invoice No.</th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Date Invoiced</th>
                        <th scope="col">Certificate Category</th>
                        <th>Invoiced By</th>
                        <th class="text-end">Amount</th>
                        <th class="text-end">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in pendingInvoicing" :key="index" class="hover-row">
                        <td class="text-nowrap">
                          <span class="badge bg-info-subtle text-info">{{ item.billNo }}</span>
                        </td>
                        <td class="text-nowrap">
                          <span class="fw-semibold">{{ item.businessID }}</span>
                        </td>
                        <td class="text-capitalize">
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm bg-light rounded-circle d-flex align-items-center justify-content-center me-2">
                              <i class="bx bx-store text-primary font-size-20"></i>
                            </div>
                            <div>
                              <h6 class="mb-0">{{ item.businessName }}</h6>
                            </div>
                          </div>
                        </td>
                        <td class="text-nowrap">
                          <div>{{ formatDate(item.dateCreated) }}</div>
                          <small class="text-muted">{{ formattedTime(item.dateCreated) }} ({{ formatTimeAgo(item.dateCreated) }})</small>
                        </td>
                        <td>
                          <span class="badge bg-primary">Industry</span>
                        </td>
                        <td class="text-capitalize">
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs bg-soft-primary rounded-circle d-flex align-items-center justify-content-center me-2">
                              <i class="bx bx-user text-primary"></i>
                            </div>
                            <span>{{ item.names }}</span>
                          </div>
                        </td>
                        <td class="text-end">
                          <span class="fw-bold text-success">KES {{ numberFormat(item.billTotal) }}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex justify-content-end gap-1">
                            <button @click="viewBusinessDetails(item)" type="button"
                                    class="btn btn-soft-primary btn-sm" title="View Details">
                              <i class="bx bx-show"></i>
                            </button>
                            <button @click="printBill(item.billNo)" class="btn btn-soft-success btn-sm" title="Print Invoice">
                              <i class="bx bx-printer"></i>
                            </button>
                            <button @click="openSMSModal(item)" type="button"
                                    class="btn btn-soft-info btn-sm" title="Resend SMS">
                              <i class="bx bx-chat"></i>
                            </button>
                            <button @click="openApprovalModal(item)" type="button"
                                    class="btn btn-soft-secondary btn-sm" title="Approve/Decline">
                              <i class="bx bx-check-shield"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="pendingInvoicing.length > 0" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{ ((pagination.currentPage - 1) * pagination.limit) + 1 }}
                        to {{ Math.min(pagination.currentPage * pagination.limit, pagination.totalRecords) }}
                        of {{ pagination.totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <li class="page-item" :class="{ disabled: !pagination.hasPreviousPage }">
                            <a class="page-link" href="javascript:void(0)" @click="changePage(pagination.currentPage - 1)">
                              <i class="mdi mdi-chevron-left"></i>
                            </a>
                          </li>

                          <!-- Page numbers -->
                          <template v-for="page in getPageNumbers()" :key="page">
                            <li v-if="page === '...'" class="page-item disabled">
                              <span class="page-link">...</span>
                            </li>
                            <li v-else class="page-item" :class="{ active: pagination.currentPage === page }">
                              <a class="page-link" href="javascript:void(0)" @click="changePage(page)">{{ page }}</a>
                            </li>
                          </template>

                          <li class="page-item" :class="{ disabled: !pagination.hasNextPage }">
                            <a class="page-link" href="javascript:void(0)" @click="changePage(pagination.currentPage + 1)">
                              <i class="mdi mdi-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Reusable Modals -->
    <BusinessDetailsModal
        :business-details="businessDetails"
        :bill-details="billDetails"
        @print-invoice="printBill"
        @print-receipt="handlePrintReceipt"
    />

    <InvoiceSMSModal
        :business="businessDetails"
        :bill-detail="billDetails"
        @resend-message="resendMessage"
    />

    <ApprovalModal
        :business-details="businessDetails"
        :bill-details="billDetails"
        :comments="comments"
        @update-comments="comments = $event"
        @approve="handleApprove"
        @decline="handleDecline"
    />

  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";
import {execute, biller, health, getRight} from "@/api";

// Import the modal components
import BusinessDetailsModal from "./modals/BusinessDetailsModal.vue";
import InvoiceSMSModal from "./modals/InvoiceSMSModal.vue";
import ApprovalModal from "./modals/ApprovalModal.vue";

export default {
  name: "PendingApprovalHygiene",
  components: {
    NavigationBar,
    ToolBarHygiene,
    BusinessDetailsModal,
    InvoiceSMSModal,
    ApprovalModal
  },
  data() {
    return {
      loading: false,
      pendingInvoicing: [],
      search: '',
      searchTimeout: null,
      message: '',
      totalBusiness: 0,
      totalAmount: 0,
      entry: null,
      businessDetails: {},
      billDetails: {},
      comments: '',
      pageSize: 25,
      filterDateRange: {
        startDate: '',
        endDate: ''
      },
      pagination: {
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        limit: 25,
        offset: 0,
        hasNextPage: false,
        hasPreviousPage: false
      }
    }
  },
  mounted() {
    this.getPendingApproval();
    this.menuAccess();
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Pending Approval Hygiene");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error('Menu access error:', e.message));
    },
    formatTimeAgo(dateString) {
      const currentDate = new Date();
      const date = new Date(dateString);
      const timeDifference = currentDate - date;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      if (daysDifference === 0) return 'Today';
      else if (daysDifference === 1) return 'Yesterday';
      else return `${daysDifference} Days Ago`;
    },
    formattedTime(originalTime) {
      const parsedTime = new Date(originalTime);
      const options = {hour: "2-digit", minute: "2-digit", hour12: true};
      return parsedTime.toLocaleTimeString([], options);
    },
    formatDate(dateString) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const date = new Date(dateString);
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },
    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },
    handleSearchInput() {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Set new timeout for debounced search
      this.searchTimeout = setTimeout(() => {
        this.pagination.currentPage = 1; // Reset to first page on search
        this.getPendingApproval();
      }, 500); // 500ms delay
    },
    handlePageSizeChange() {
      this.pagination.currentPage = 1; // Reset to first page
      this.pagination.limit = parseInt(this.pageSize);
      this.getPendingApproval();
    },
    getPendingApproval(page = null) {
      this.loading = true;
      const currentPage = page || this.pagination.currentPage;

      const data = new FormData();
      data.append("function", "getPendingApproval");
      data.append("keyword", this.search);
      data.append("statusID", "4");
      data.append("page", currentPage);
      data.append("limit", this.pageSize);

      // Add date range filters if set
      if (this.filterDateRange.startDate) {
        data.append("startDate", this.filterDateRange.startDate);
      }
      if (this.filterDateRange.endDate) {
        data.append("endDate", this.filterDateRange.endDate);
      }

      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.pendingInvoicing = res.data.data.pendingInvoicing || [];
              this.pagination = res.data.data.pagination || this.pagination;

              // Update summary from backend response
              const summary = res.data.data.summary || {};
              this.totalBusiness = summary.totalBusinesses || 0;
              this.totalAmount = summary.totalAmount || 0;
            } else {
              this.message = res.data.message;
              this.pendingInvoicing = [];
              this.totalBusiness = 0;
              this.totalAmount = 0;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
            this.pendingInvoicing = [];
            console.error('Error fetching pending approvals:', e);
          });
    },
    viewBusinessDetails(item) {
      this.entry = item;
      this.loading = true;
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", item.businessID);
      data.append("billNo", item.billNo);
      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.businessDetails = res.data.data.business;
              this.billDetails = res.data.data.bill.billDetails;
              const modal = new bootstrap.Modal(document.querySelector('.receipting-modal'));
              modal.show();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            alert('Error loading business details: ' + e.message);
          });
    },
    openSMSModal(item) {
      this.entry = item;
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", item.businessID);
      data.append("billNo", item.billNo);
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.businessDetails = res.data.data.business;
              this.billDetails = res.data.data.bill.billDetails;
              const modal = new bootstrap.Modal(document.querySelector('.SMS-modal'));
              modal.show();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => alert('Error: ' + e.message));
    },
    openApprovalModal(item) {
      this.entry = item;
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", item.businessID);
      data.append("billNo", item.billNo);
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.businessDetails = res.data.data.business;
              this.billDetails = res.data.data.bill.billDetails;
              this.comments = '';
              const modal = new bootstrap.Modal(document.getElementById('approval-modal'));
              modal.show();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => alert('Error: ' + e.message));
    },
    resendMessage() {
      const data = new FormData();
      data.append("function", "resendMessage");
      data.append("customerPhoneNumber", this.businessDetails.ownerPhone);
      data.append("incomeTypePrefix", this.billDetails.incomeTypePrefix);
      data.append("billNo", this.billDetails.billNo);
      data.append("name", this.businessDetails.businessName);
      execute(data, biller)
          .then((res) => alert(res.data.message))
          .catch((e) => alert('Error: ' + e.message));
    },
    printBill(billNo) {
      localStorage['params'] = JSON.stringify({billNo: billNo});
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    handlePrintReceipt() {
      alert('Print receipt functionality to be implemented');
    },
    handleApprove() {
      this.approveHealthPermit('APPROVE');
    },
    handleDecline() {
      if (!this.comments || this.comments.trim() === '') {
        alert('Please provide a reason for declining');
        return;
      }
      this.approveHealthPermit('DECLINE');
    },
    approveHealthPermit(declineApprove) {
      const data = new FormData();
      data.append("function", "approveHealthPermit");
      data.append("comments", this.comments);
      data.append("billNo", this.entry.billNo);
      data.append("statusID", Number(this.entry.statusID) + 1);
      data.append("idNo", sessionStorage.getItem("idNo"));
      data.append("names", sessionStorage.getItem("names"));
      data.append("phoneNumber", sessionStorage.getItem("phoneNumber"));
      data.append("balanceAmount", this.billDetails.billBalance);
      data.append("stageStatus", this.entry.stageStatus);
      data.append("ownerPhone", "");
      data.append("declineApprove", declineApprove);
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message || `Permit ${declineApprove === 'APPROVE' ? 'approved' : 'declined'} successfully`);
              const modalElement = document.getElementById('approval-modal');
              const modal = bootstrap.Modal.getInstance(modalElement);
              if (modal) modal.hide();
              this.getPendingApproval();
              this.comments = '';
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => alert('Error: ' + e.message));
    },
    applyDateFilter() {
      this.pagination.currentPage = 1; // Reset to first page
      this.getPendingApproval();
    },
    clearDateFilter() {
      this.filterDateRange.startDate = '';
      this.filterDateRange.endDate = '';
      this.pagination.currentPage = 1;
      this.getPendingApproval();
    },
    clearAllFilters() {
      this.search = '';
      this.filterDateRange.startDate = '';
      this.filterDateRange.endDate = '';
      this.pagination.currentPage = 1;
      this.getPendingApproval();
    },
    exportToCSV() {
      try {
        // Prepare CSV headers
        const headers = [
          'Invoice No',
          'Business ID',
          'Business Name',
          'Date Invoiced',
          'Category',
          'Invoiced By',
          'Amount (KES)'
        ];

        // Prepare CSV rows from current data
        const rows = this.pendingInvoicing.map(item => [
          item.billNo || '',
          item.businessID || '',
          item.businessName || '',
          this.formatDate(item.dateCreated) + ' ' + this.formattedTime(item.dateCreated),
          'Industry',
          item.names || '',
          item.billTotal || 0
        ]);

        // Create CSV content
        let csvContent = headers.join(',') + '\n';

        rows.forEach(row => {
          // Escape fields that contain commas or quotes
          const escapedRow = row.map(field => {
            const stringField = String(field);
            if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
              return `"${stringField.replace(/"/g, '""')}"`;
            }
            return stringField;
          });
          csvContent += escapedRow.join(',') + '\n';
        });

        // Add summary row
        csvContent += '\n';
        csvContent += `Total Records,${this.pagination.totalRecords}\n`;
        csvContent += `Total Businesses,${this.totalBusiness}\n`;
        csvContent += `Total Amount,KES ${this.numberFormat(this.totalAmount)}\n`;

        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `pending-approval-hygiene-${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Show success message
        alert(`Successfully exported ${this.pendingInvoicing.length} records from page ${this.pagination.currentPage}. Total records: ${this.pagination.totalRecords}`);
      } catch (error) {
        console.error('Export error:', error);
        alert('Error exporting data to CSV. Please try again.');
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.pagination.totalPages) {
        this.pagination.currentPage = page;
        this.getPendingApproval(page);
      }
    },
    getPageNumbers() {
      const current = this.pagination.currentPage;
      const total = this.pagination.totalPages;
      const delta = 2; // Number of pages to show on each side of current page
      const pages = [];

      if (total <= 7) {
        // Show all pages if total is 7 or less
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // Always show first page
        pages.push(1);

        // Calculate range around current page
        let start = Math.max(2, current - delta);
        let end = Math.min(total - 1, current + delta);

        // Add ellipsis after first page if needed
        if (start > 2) {
          pages.push('...');
        }

        // Add pages in range
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        // Add ellipsis before last page if needed
        if (end < total - 1) {
          pages.push('...');
        }

        // Always show last page
        pages.push(total);
      }

      return pages;
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body { padding: 20px; }
.mini-stat-icon { width: 48px; height: 48px; }
.hover-row { transition: all 0.3s ease; cursor: pointer; }
.hover-row:hover { background-color: #f8f9fa !important; transform: translateX(2px); }
.btn-soft-primary { color: #556ee6; background-color: rgba(85, 110, 230, 0.18); border: none; }
.btn-soft-primary:hover { color: #fff; background-color: #556ee6; }
.btn-soft-success { color: #34c38f; background-color: rgba(52, 195, 143, 0.18); border: none; }
.btn-soft-success:hover { color: #fff; background-color: #34c38f; }
.btn-soft-info { color: #50a5f1; background-color: rgba(80, 165, 241, 0.18); border: none; }
.btn-soft-info:hover { color: #fff; background-color: #50a5f1; }
.btn-soft-secondary { color: #74788d; background-color: rgba(116, 120, 141, 0.18); border: none; }
.btn-soft-secondary:hover { color: #fff; background-color: #74788d; }
.badge { padding: 0.5em 0.75em; font-weight: 500; }
.bg-info-subtle { background-color: rgba(80, 165, 241, 0.18); color: #50a5f1; }
.table > :not(caption) > * > * { padding: 0.75rem; }
.avatar-sm { height: 2.5rem; width: 2.5rem; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.avatar-xs { height: 2rem; width: 2rem; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.avatar-title { display: flex; align-items: center; justify-content: center; height: 100%; width: 100%; }
.bg-light { background-color: #f3f3f9 !important; }
.rounded-circle { border-radius: 50% !important; }
.font-size-18 { font-size: 18px !important; }
.font-size-20 { font-size: 20px !important; }
.font-size-24 { font-size: 24px !important; }
.font-size-64 { font-size: 64px; }
.card { box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; }
.card-header { background-color: #fff; border-bottom: 1px solid #eff2f7; }
.pagination { margin-bottom: 0; }
.page-link { color: #556ee6; border: 1px solid #dee2e6; }
.page-item.active .page-link { background-color: #556ee6; border-color: #556ee6; }
.dataTables_info { color: #74788d; font-weight: 500; }
.spinner-border { width: 3rem; height: 3rem; }
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.app-search .form-control { border: 1px solid #ced4da; padding-left: 40px; }
.app-search .bx-search-alt { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); font-size: 16px; color: #74788d; }
@media (max-width: 768px) {
  .table-responsive { font-size: 0.875rem; }
  .btn-sm { padding: 0.25rem 0.5rem; font-size: 0.75rem; }
  .card-body { padding: 1rem; }
  .d-flex.align-items-center { flex-wrap: wrap; gap: 10px; }
}
</style>